/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Resources/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Resources({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/Booking/Resources"
  
}) {
let patientBookingValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'booking',
format: fromHelpers.getResources,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient.booking"
 format="helpers.js getResources"
 text={patientBookingValueData}
 size="small"
/>
{children}
</React.Fragment>)
}